var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8788 1.42801C16.6336 0.672989 17.6575 0.248763 18.7252 0.248657C19.7928 0.248552 20.8168 0.672575 21.5718 1.42745C22.3268 2.18232 22.7511 3.20621 22.7512 4.27386C22.7513 5.34152 22.3272 6.36549 21.5724 7.12051L20.5689 8.12401L14.8764 2.43151L15.8788 1.42801ZM13.6839 3.62401L2.43388 14.8729C1.97671 15.3302 1.65542 15.9054 1.50575 16.5345L0.273877 21.7106C0.240522 21.8509 0.243649 21.9973 0.28296 22.136C0.322271 22.2747 0.396454 22.401 0.498436 22.5028C0.600417 22.6047 0.726795 22.6787 0.865518 22.7179C1.00424 22.7571 1.15068 22.76 1.29088 22.7265L6.467 21.4946C7.09623 21.3447 7.67147 21.023 8.12863 20.5654L19.3764 9.31876L13.6839 3.62401Z",
    fill: "#FBB516"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.2c4c9ec60080005d26ea6bacda599c81.svg";
export { ForwardRef as ReactComponent };